<template>
    <div>
        <div class="row">
            <div class="col-lg-8">
                <div v-if="new_questions.length > 0" class="alert alert-info" role="alert">
                    There are {{ new_questions.length }} questions since last update, click <a href="#" @click.prevent="add_new()">here</a> to update the question list
                </div>
                <div v-else class="alert alert-secondary" role="alert">
                    There are no new questions since last update at {{ last_refresh }}
                </div>
                <ul class="nav nav-tabs" id="question-tab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="available-questions-tab" data-toggle="tab" href="#available-questions" role="tab" aria-controls="avaliable" aria-selected="true">Available</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="answered-questions-tab" data-toggle="tab" href="#answered-questions" role="tab" aria-controls="answered" aria-selected="false">Answered</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="skipped-questions-tab" data-toggle="tab" href="#skipped-questions" role="tab" aria-controls="skipped" aria-selected="false">Skipped</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="starred-questions-tab" data-toggle="tab" href="#starred-questions" role="tab" aria-controls="starred" aria-selected="false">Starred</a>
                    </li>
                </ul>
                <div class="tab-content" id="question-tab-content">
                    <div class="tab-pane fade show active" id="available-questions" role="tabpanel" aria-labelledby="available-tab">
                        <vue-bootstrap4-table :rows="available_questions" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort text-gray-200"></i>
                            </template>
                            <template slot="seq" slot-scope="props">
                                <span style="font-size: 0.9rem">{{ props.row.seq }}</span>
                            </template>
                            <template slot="question" slot-scope="props">
                                <div v-if="props.row.starred_at" class="float-right text-success">
                                    <a @click="unstar(props.row)" style="cursor: pointer;"><i class="fas fa-star"></i></a>
                                </div>
                                <div v-else class="float-right">
                                    <a @click="star(props.row)" style="cursor: pointer;"><i class="far fa-star"></i></a>
                                </div>
                                <span style="font-size: 0.9rem"><span class="font-weight-bold">{{ props.row.name }}</span> from <span class="font-italic">{{props.row.company}}</span></span>
                                <p style="font-size: 0.9rem"><nl2br tag="span" :text="props.row.question" class-name="" /></p>
                                <div class="float-left">
                                    <span v-if="props.row.skipped_at" class="badge badge-secondary">Skipped</span>
                                    <span v-if="props.row.queued_at" class="badge badge-success">Queued</span>
                                    <span v-if="props.row.answered_at" class="badge badge-primary">Answered</span>
                                </div>
                                <div class="float-right">
                                    <button class="btn btn-primary btn-sm btn-icon-split" @click="edit(props.row)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-pen"></i>
                                        </span>
                                        <span class="text">Edit and Save As New</span>
                                    </button>
                                    <button v-if="props.row.skipped_at" class="btn btn-secondary btn-sm btn-icon-split" @click="unskip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Un-skip</span>
                                    </button>
                                    <button v-else class="btn btn-secondary btn-sm btn-icon-split" @click="skip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Skip</span>
                                    </button>
                                    <button class="btn btn-success btn-sm btn-icon-split" @click="queue(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                        <span class="text">Add to Queue</span>
                                    </button>
                                </div>
                            </template>
                            <template slot="created_at" slot-scope="props">
                                <span style="font-size: 0.9rem;white-space:nowrap;">{{ moment(props.row.created_at).format('H:mm') }}</span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                    <div class="tab-pane fade" id="answered-questions" role="tabpanel" aria-labelledby="answered-tab">
                        <vue-bootstrap4-table :rows="answered_questions" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort text-gray-200"></i>
                            </template>
                            <template slot="seq" slot-scope="props">
                                <span style="font-size: 0.9rem">{{ props.row.seq }}</span>
                            </template>
                            <template slot="question" slot-scope="props">
                                <div v-if="props.row.starred_at" class="float-right text-success">
                                    <a @click="unstar(props.row)" style="cursor: pointer;"><i class="fas fa-star"></i></a>
                                </div>
                                <div v-else class="float-right">
                                    <a @click="star(props.row)" style="cursor: pointer;"><i class="far fa-star"></i></a>
                                </div>
                                <span style="font-size: 0.9rem"><span class="font-weight-bold">{{ props.row.name }}</span> from <span class="font-italic">{{props.row.company}}</span></span>
                                <p style="font-size: 0.9rem"><nl2br tag="span" :text="props.row.question" class-name="" /></p>
                                <div class="float-left">
                                    <span v-if="props.row.skipped_at" class="badge badge-secondary">Skipped</span>
                                    <span v-if="props.row.queued_at" class="badge badge-success">Queued</span>
                                    <span v-if="props.row.answered_at" class="badge badge-primary">Answered</span>
                                </div>
                                <div class="float-right">
                                    <button class="btn btn-primary btn-sm btn-icon-split" @click="edit(props.row)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-pen"></i>
                                        </span>
                                        <span class="text">Edit and Save As New</span>
                                    </button>
                                    <button v-if="props.row.skipped_at" class="btn btn-secondary btn-sm btn-icon-split" @click="unskip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Un-skip</span>
                                    </button>
                                    <button v-else class="btn btn-secondary btn-sm btn-icon-split" @click="skip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Skip</span>
                                    </button>
                                    <button class="btn btn-success btn-sm btn-icon-split" @click="queue(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                        <span class="text">Add to Queue</span>
                                    </button>
                                </div>
                            </template>
                            <template slot="created_at" slot-scope="props">
                                <span style="font-size: 0.9rem;white-space:nowrap;">{{ moment(props.row.created_at).format('H:mm') }}</span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                    <div class="tab-pane fade" id="skipped-questions" role="tabpanel" aria-labelledby="skipped-tab">
                        <vue-bootstrap4-table :rows="skipped_questions" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort text-gray-200"></i>
                            </template>
                            <template slot="seq" slot-scope="props">
                                <span style="font-size: 0.9rem">{{ props.row.seq }}</span>
                            </template>
                            <template slot="question" slot-scope="props">
                                <div v-if="props.row.starred_at" class="float-right text-success">
                                    <a @click="unstar(props.row)" style="cursor: pointer;"><i class="fas fa-star"></i></a>
                                </div>
                                <div v-else class="float-right">
                                    <a @click="star(props.row)" style="cursor: pointer;"><i class="far fa-star"></i></a>
                                </div>
                                <span style="font-size: 0.9rem"><span class="font-weight-bold">{{ props.row.name }}</span> from <span class="font-italic">{{props.row.company}}</span></span>
                                <p style="font-size: 0.9rem"><nl2br tag="span" :text="props.row.question" class-name="" /></p>
                                <div class="float-left">
                                    <span v-if="props.row.skipped_at" class="badge badge-secondary">Skipped</span>
                                    <span v-if="props.row.queued_at" class="badge badge-success">Queued</span>
                                    <span v-if="props.row.answered_at" class="badge badge-primary">Answered</span>
                                </div>
                                <div class="float-right">
                                    <button class="btn btn-primary btn-sm btn-icon-split" @click="edit(props.row)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-pen"></i>
                                        </span>
                                        <span class="text">Edit and Save As New</span>
                                    </button>
                                    <button v-if="props.row.skipped_at" class="btn btn-secondary btn-sm btn-icon-split" @click="unskip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Un-skip</span>
                                    </button>
                                    <button v-else class="btn btn-secondary btn-sm btn-icon-split" @click="skip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Skip</span>
                                    </button>
                                    <button class="btn btn-success btn-sm btn-icon-split" @click="queue(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                        <span class="text">Add to Queue</span>
                                    </button>
                                </div>
                            </template>
                            <template slot="created_at" slot-scope="props">
                                <span style="font-size: 0.9rem;white-space:nowrap;">{{ moment(props.row.created_at).format('H:mm') }}</span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>

                    <div class="tab-pane fade" id="starred-questions" role="tabpanel" aria-labelledby="starred-tab">
                        <vue-bootstrap4-table :rows="starred_questions" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort text-gray-200"></i>
                            </template>
                            <template slot="seq" slot-scope="props">
                                <span style="font-size: 0.9rem">{{ props.row.seq }}</span>
                            </template>
                            <template slot="question" slot-scope="props">
                                <div v-if="props.row.starred_at" class="float-right text-success">
                                    <a @click="unstar(props.row)" style="cursor: pointer;"><i class="fas fa-star"></i></a>
                                </div>
                                <div v-else class="float-right">
                                    <a @click="star(props.row)" style="cursor: pointer;"><i class="far fa-star"></i></a>
                                </div>
                                <span style="font-size: 0.9rem"><span class="font-weight-bold">{{ props.row.name }}</span> from <span class="font-italic">{{props.row.company}}</span></span>
                                <p style="font-size: 0.9rem"><nl2br tag="span" :text="props.row.question" class-name="" /></p>
                                <div class="float-left">
                                    <span v-if="props.row.skipped_at" class="badge badge-secondary">Skipped</span>
                                    <span v-if="props.row.queued_at" class="badge badge-success">Queued</span>
                                    <span v-if="props.row.answered_at" class="badge badge-primary">Answered</span>
                                </div>
                                <div class="float-right">
                                    <button class="btn btn-primary btn-sm btn-icon-split" @click="edit(props.row)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-pen"></i>
                                        </span>
                                        <span class="text">Edit and Save As New</span>
                                    </button>
                                    <button v-if="props.row.skipped_at" class="btn btn-secondary btn-sm btn-icon-split" @click="unskip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Un-skip</span>
                                    </button>
                                    <button v-else class="btn btn-secondary btn-sm btn-icon-split" @click="skip(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Skip</span>
                                    </button>
                                    <button class="btn btn-success btn-sm btn-icon-split" @click="queue(props.row)" :disabled="props.row.queued_at">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                        <span class="text">Add to Queue</span>
                                    </button>
                                </div>
                            </template>
                            <template slot="created_at" slot-scope="props">
                                <span style="font-size: 0.9rem;white-space:nowrap;">{{ moment(props.row.created_at).format('H:mm') }}</span>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                </div>


            </div>
            <div class="col-lg-4">
                <h5>Queued Questions</h5>
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Question</th>
                    </tr>
                    </thead>
                    <draggable v-model="queued_questions" tag="tbody"
                               v-bind="dragOptions"
                               @start=""
                               @end="updateQueue()">
                        <tr v-for="q in queued_questions" :key="q.seq" style="cursor: ns-resize;">
                            <td>{{ q.seq }}</td>
                            <td>
                                <div v-if="q.starred_at" class="float-right text-success">
                                    <a @click="unstar(q)" style="cursor: pointer;"><i class="fas fa-star"></i></a>
                                </div>
                                <div v-else class="float-right">
                                    <a @click="star(q)" style="cursor: pointer;"><i class="far fa-star"></i></a>
                                </div>
                                <span style="font-size: 0.9rem"><span class="font-weight-bold">{{ q.name }}</span> from <span class="font-italic">{{q.company}}</span></span>
                                <p style="font-size: 0.9rem"><nl2br tag="span" :text="q.question" class-name="" /></p>
                                <div class="float-left">
                                    <!--<button class="btn btn-secondary btn-sm btn-icon-split" @click="skip(q)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-trash "></i>
                                        </span>
                                        <span class="text">Skip</span>
                                    </button>-->
                                    <button class="btn btn-success btn-sm btn-icon-split" @click="unqueue(q)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-chevron-left"></i>
                                        </span>
                                        <span class="text">Remove from Queue</span>
                                    </button>
                                    <button class="btn btn-primary btn-sm btn-icon-split" @click="answer(q)">
                                        <span class="icon text-white-50">
                                            <i class="fas fa-check "></i>
                                        </span>
                                        <span class="text">Answered</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </div>
            <div class="modal fade" id="edit-question-modal" tabindex="-1" role="dialog" aria-labelledby="edit-question" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">Edit and Save As New</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <textarea v-model="edit_question.question" class="form-control" rows="5"></textarea>
                        </div>
                        <div class="modal-footer">

                            <button class="btn btn-secondary btn-sm btn-icon-split" data-dismiss="modal">
                                <span class="icon text-white-50">
                                    <i class="fas fa-times"></i>
                                </span>
                                <span class="text">Cancel</span>
                            </button>
                            <button class="btn btn-success btn-sm btn-icon-split" @click="save_as_new" >
                                <span class="icon text-white-50">
                                    <i class="fas fa-save"></i>
                                </span>
                                <span class="text">Save As New</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import draggable from 'vuedraggable'
    var moment = require('moment')
    moment().format()

    export default {
        name: "QuestionList",

        props: {
            webcast_hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        data() {
            return {
                questions: [],
                queued_questions:[],
                new_questions:[],
                edit_question: {
                    question: null
                },
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "#",
                            name: "seq",
                            sort: true,
                            row_text_alignment:  "text-right",
                            column_text_alignment:  "text-right",
                            initial_sort: true, // "false" by default
                            initial_sort_order: "desc", // "asc" by default
                            slot_name: "seq"
                        },
                        {
                            label: "Question",
                            name: "question",
                            sort: false,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            slot_name: "question"
                        },
                        {
                            label: "Time",
                            name: "created_at",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    }
                },
                refresh_timer: null,
                last_refresh: null,
                toastr_options: {
                    "closeButton": false,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": false,
                    "positionClass": "toast-top-right",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                }
            }
        },
        components: {
            VueBootstrap4Table,
            draggable,
        },
        computed: {
            available_questions: function () {
                var a = _.map(this.questions, function(o) {
                    if (o.skipped_at == null && o.queued_at == null && o.answered_at == null) return o;
                });
                return _.without(a, undefined)
            },
            skipped_questions: function () {
                var a = _.map(this.questions, function(o) {
                    if (o.skipped_at != null) return o;
                });
                return _.without(a, undefined)
            },
            answered_questions: function () {
                var a = _.map(this.questions, function(o) {
                    if (o.answered_at != null) return o;
                });
                return _.without(a, undefined)
            },
            starred_questions: function () {
                var a = _.map(this.questions, function(o) {
                    if (o.starred_at != null) return o;
                });
                return _.without(a, undefined)
            },
            /*queued_questions: function () {
                var a = _.map(this.questions, function(o) {
                    if (o.queued_at != null) return o;
                });
                return _.without(a, undefined)
                //return _.orderBy(a, ['queued_order'],['asc'])
            },*/

            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        mounted() {
            axios.get('/api/webcast/'+ this.webcast_hashid +'/question').then((response) => {
                this.questions = response.data.questions
                this.queued_questions = response.data.queued_questions
                this.refresh_timer = setInterval(() => {this.refresh()}, 10000)
            }).catch((error) => {
                Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                    location.href='/webcast/'+this.webcast_hashid
                });
            });
            this.last_refresh = moment().format('H:mm:ss')
        },
        methods: {

            moment(date) {
                return moment(date)
            },
            queue(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/queue').then((response) => {
                    question = _.assign(question, response.data.question)
                    this.queued_questions = response.data.queued_questions
                    //this.$toastr.info("<p>Question #"+question.seq+" has been added to queue</p><button type=\"button\" id=\"okBtn\" class=\"btn btn-sm btn-warning\" @click='unqueue(row)'>Undo</button>", null, this.toastr_options)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            unqueue(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/unqueue').then((response) => {
                    question = _.assign(question, response.data.question)
                    this.queued_questions = response.data.queued_questions

                    //this.$toastr.info("<p>Question #"+question.seq+" has been removed to queue</p><button type=\"button\" id=\"okBtn\" class=\"btn btn-sm btn-warning\">Undo</button>", null, this.toastr_options)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            skip(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/skip').then((response) => {
                    question = _.assign(question, response.data.question)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            unskip(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/unskip').then((response) => {
                    question = _.assign(question, response.data.question)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            answer(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/answer').then((response) => {
                    question = _.assign(question, response.data.question)
                    this.queued_questions = response.data.queued_questions
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            unanswer(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/unanswer').then((response) => {
                    question = _.assign(question, response.data.question)
                    this.queued_questions = response.data.queued_questions
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            star(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/star').then((response) => {
                    question = _.assign(question, response.data.question)

                    var queued_question = _.find(this.queued_questions, ['hashid', row.hashid])
                    queued_question = _.assign(queued_question, response.data.question)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            unstar(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                axios.patch('/api/question/'+row.hashid+'/unstar').then((response) => {
                    question = _.assign(question, response.data.question)

                    var queued_question = _.find(this.queued_questions, ['hashid', row.hashid])
                    queued_question = _.assign(queued_question, response.data.question)
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            edit(row) {
                var question = _.find(this.questions, ['hashid', row.hashid])
                this.edit_question = _.clone(question)
                $('#edit-question-modal').modal()
            },
            save_as_new() {
                axios.post('/api/question/'+ this.edit_question.hashid +'/save_as_new',{'question': this.edit_question.question,'name': this.edit_question.name,'company': this.edit_question.company,'email': this.edit_question.email}).then((response) => {
                    //this.questions = response.data.questions
                    $('#edit-question-modal').modal('hide')
                    this.refresh(true)

                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            updateQueue() {
                var a = _.map(this.queued_questions,"hashid")
                axios.patch('/api/question/reorder', {'order': a}).then((response) => {
                    this.queued_questions = response.data.queued_questions
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            refresh(auto = false) {
                var max = _.maxBy(this.questions, 'seq')
                axios.get('/api/question/'+ max.hashid +'/refresh').then((response) => {
                    this.new_questions = response.data.questions
                    this.last_refresh = moment().format('H:mm:ss')
                    if (auto)
                    {
                        if (this.new_questions.length > 0)
                            this.$toastr.info(""+ this.new_questions.length +" question(s) have been added to list", null, this.toastr_options)

                        this.add_new()
                    }
                    else
                    {
                        if (this.new_questions.length > 0)
                            this.$toastr.info("There are "+ this.new_questions.length +" question(s) since last update, please update the question list", null, this.toastr_options)

                    }
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to perform request, please try again or reload this page if the situration continues',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                    })
                })
            },
            add_new() {
                this.questions = this.questions.concat(this.new_questions)
                this.new_questions = []
            }
        }
    }

</script>

<style>
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

</style>
